import { useEffect, useState } from "react";
import "../ProjetoLicenciamentoAmbiental/Projeto.css";
import BannerPaginaInterna from "../BannerPaginaInterna/BannerPaginaInterna.js";
import Projetos from "../Projetos/Projetos.js";
import Contato from "../Contato/Contato.js";
import recupAreaDegradada1 from "../../assets/img/projetos/recupAreaDegradada1.png";
import recupAreaDegradada2 from "../../assets/img/projetos/recupAreaDegradada2.png";
import Servicos from "../Servicos/Servicos.js";
import { FaMountain, FaSeedling, FaWater, FaShieldAlt } from "react-icons/fa";

function ProjetoRecuperacaoAreasDegradadas() {
  const [openItem, setOpenItem] = useState(1);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll(".scroll-reveal-zoom");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.2 },
    );

    elements.forEach((el) => observer.observe(el));
    return () => elements.forEach((el) => observer.unobserve(el));
  }, []);

  const itens = [
    {
      icon: <FaShieldAlt />,
      titulo: "Controle de Erosão",
      desc: "Redução dos processos erosivos e proteção do solo",
    },
    {
      icon: <FaMountain />,
      titulo: "Estabilização de Taludes",
      desc: "Segurança geotécnica e reconfiguração do terreno",
    },
    {
      icon: <FaSeedling />,
      titulo: "Recomposição Vegetal",
      desc: "Recuperação da cobertura vegetal e equilíbrio ambiental",
    },
    {
      icon: <FaWater />,
      titulo: "Disciplinamento Hídrico",
      desc: "Controle e direcionamento adequado das águas",
    },
  ];

  return (
<div className="bg-white">
      <BannerPaginaInterna
        tag="Restauração de áreas"
        titulo="Projeto de Recuperação de Áreas Degradadas(PRAD)"
        descricao="Recuperar uma área degradada por mineração começa com um projeto técnico bem estruturado."
        textoBotao="Solicitar Orçamento"
        rotaBotao="https://wa.me/5532984053160?text=Olá, quero um orçamento para Projeto de Recuperação de Áreas Degradadas(PRAD)"
        mostrarBotaoOutline={true}
        textoBotaoOutline="Fale com Especialista"
        rotaBotaoOutline="https://wa.me/5532984053160?text=Olá, quero falar com um especialista em Projeto de Recuperação de Áreas Degradadas(PRAD)"
      />

      <main className="projetos-page py-5 container">
        <section className="s scroll-reveal-zoom">
          <div className="titulo-bloco">
            <h2>Projeto de Recuperação de Áreas Degradadas(PRAD)</h2>
            <p>
              Projeto Técnico para Estabilização de Área Crítica de Mineração
            </p>
          </div>

          <div className="scroll-reveal-zoom">
            <p>
              Recuperar uma área degradada por mineração começa com um projeto
              técnico bem estruturado. Este case apresenta a elaboração de um{" "}
              <strong>PRAD (Projeto de Recuperação de Área Degradada)</strong>{" "}
              para uma área de aproximadamente 7 hectares, localizada em bioma
              de Mata Atlântica, caracterizada por um cenário avançado de
              degradação decorrente de lavra irregular.
            </p>

            <p>
              O trabalho teve como foco o desenvolvimento de uma solução técnica
              capaz de{" "}
              <strong>
                restabelecer a estabilidade geotécnica, controlar processos
                erosivos e viabilizar o uso futuro da área
              </strong>
              , especialmente considerando a intenção de retomada da atividade
              minerária no local.
            </p>
          </div>

          <section className="images-section scroll-reveal-zoom">
            <div className="container">
              <div className="images-grid">
                <div className="image-card">
                  <img src={recupAreaDegradada1} alt="" className="img-fluid" />
                </div>

                <div className="image-card">
                  <img src={recupAreaDegradada2} alt="Imagem secundária" />
                </div>
              </div>
            </div>
          </section>

          <div className="case-destaque scroll-reveal-zoom">
            <h5>Quando a Área Degradada Impede a Continuidade da Operação</h5>
            <p>
              O <strong>diagnóstico inicial</strong> evidenciou um cenário de{" "}
              <strong>alta criticidade</strong>. A área apresentava uma grande
              cava resultante de exploração irregular, com taludes que atingiam
              até <strong>75 metros de altura</strong>, presença de{" "}
              <strong>voçorocas ativas</strong> e{" "}
              <strong>processos erosivos em evolução</strong>.
            </p>

            <p>
              O solo, predominantemente{" "}
              <strong>areno-siltoso e pouco coeso</strong>, associado à{" "}
              <strong>ausência de drenagem adequada</strong>, favorecia
              instabilidades constantes. Em diversos trechos, as inclinações
              chegavam a <strong>90°</strong>, configurando{" "}
              <strong>risco geotécnico elevado</strong>.
            </p>

            <p>
              Além dos impactos ambientais, como <strong>assoreamento</strong> e{" "}
              <strong>perda de cobertura vegetal</strong>, havia um fator
              decisivo: a{" "}
              <strong>inviabilidade técnica e operacional da área</strong> sem
              uma solução estruturada de recuperação. A continuidade da
              atividade minerária dependia diretamente da{" "}
              <strong>estabilização do terreno</strong>.
            </p>
          </div>

          <div className="case-destaque scroll-reveal-zoom">
            <h5>
              A Solução: Projeto de PRAD com Foco em Estabilidade e Viabilidade
            </h5>
            <p>
              A atuação foi concentrada na{" "}
              <strong>
                elaboração de um projeto de recuperação de área degradada (PRAD)
              </strong>{" "}
              tecnicamente consistente, orientado por critérios de{" "}
              <strong>
                estabilidade, controle hidrológico e recomposição vegetal
              </strong>
              .
            </p>

            <p>
              O desenvolvimento do projeto foi baseado em{" "}
              <strong>diagnóstico detalhado</strong>, incluindo{" "}
              <strong>
                levantamento topográfico de alta precisão com uso de drone
              </strong>
              , <strong>visitas técnicas</strong> e{" "}
              <strong>análises via geoprocessamento</strong>. Esse conjunto
              permitiu compreender a dinâmica da área e propor{" "}
              <strong>
                soluções compatíveis com suas limitações físicas e operacionais
              </strong>
              .
            </p>

            <p>
              A estratégia técnica priorizou{" "}
              <strong>
                soluções com bom custo-benefício e alta eficiência
              </strong>
              , combinando <strong>engenharia de conformação do terreno</strong>{" "}
              com <strong>técnicas de bioengenharia</strong>.
            </p>
          </div>

          <div className="case-destaque scroll-reveal-zoom">
            <h5>Soluções Técnicas Propostas no PRAD</h5>
            <p>
              O projeto estruturou um{" "}
              <strong>conjunto integrado de intervenções</strong>, com foco na{" "}
              <strong>estabilização e recuperação funcional da área</strong>.
            </p>

            <p>
              Foi proposto o <strong>reperfilamento dos taludes</strong>, com
              redução das <strong>inclinações críticas</strong> e adaptação à
              topografia local, garantindo maior{" "}
              <strong>estabilidade geotécnica</strong>. A solução incluiu a
              criação de{" "}
              <strong>
                bermas intermediárias com cerca de 4 metros de largura
              </strong>
              , permitindo{" "}
              <strong>dissipação de energia das águas pluviais</strong> e maior{" "}
              <strong>segurança operacional</strong>.
            </p>

            <p>
              O <strong>disciplinamento da drenagem</strong> foi um dos pilares
              do projeto, com definição de estruturas para{" "}
              <strong>condução adequada das águas</strong> e{" "}
              <strong>redução do carreamento de sedimentos</strong>, atuando
              diretamente no <strong>controle dos processos erosivos</strong>.
            </p>

            <p>
              Para <strong>estabilização superficial</strong>, foram
              especificadas <strong>técnicas de bioengenharia</strong>, com uso
              de <strong>capim vetiver</strong> como elemento de contenção
              natural, associado à{" "}
              <strong>hidrossemeadura de gramíneas e leguminosas</strong> para
              rápida cobertura do solo.
            </p>

            <p>
              Como medida complementar, foi recomendada a utilização de{" "}
              <strong>biomantas vegetais</strong>, com função de{" "}
              <strong>proteção superficial</strong> e{" "}
              <strong>estímulo ao desenvolvimento da vegetação</strong>.
            </p>

            <p>
              O projeto também contemplou{" "}
              <strong>diretrizes de correção do solo</strong>, incluindo{" "}
              <strong>calagem e adubação</strong>, com definição de{" "}
              <strong>insumos e dosagens adequadas</strong> para garantir o
              estabelecimento da cobertura vegetal.
            </p>
          </div>

          <div className="case-destaque scroll-reveal-zoom">
            <h5>
              Resultado do Projeto: Base Técnica para Recuperação e Segurança
            </h5>
            <p>
              A entrega do <strong>PRAD</strong> forneceu uma{" "}
              <strong>base técnica completa</strong> para a recuperação da área,
              permitindo a{" "}
              <strong>execução estruturada das intervenções</strong> necessárias
              para <strong>estabilização e controle ambiental</strong>.
            </p>

            <p>
              O projeto possibilitou transformar um{" "}
              <strong>cenário de degradação avançada</strong> em um{" "}
              <strong>plano viável de recuperação</strong>, com{" "}
              <strong>diretrizes claras</strong> para:
            </p>

            <ul className="lista-prad">
              <li>
                <strong>controle de erosão</strong>
              </li>
              <li>
                <strong>estabilização de taludes</strong>
              </li>
              <li>
                <strong>recomposição vegetal</strong>
              </li>
              <li>
                <strong>disciplinamento hídrico</strong>
              </li>
            </ul>
            <p>
              Além disso, estabeleceu as condições necessárias para viabilizar
              com segurança a futura retomada da atividade minerária no local.
            </p>
          </div>

          <div className="case-destaque scroll-reveal-zoom">
            <h5>Impacto: Engenharia Aplicada à Recuperação Ambiental</h5>
            <p>
              Mesmo sem a etapa de implantação, o desenvolvimento do{" "}
              <strong>PRAD</strong> teve{" "}
              <strong>impacto direto na viabilidade do empreendimento</strong>,
              ao fornecer{" "}
              <strong>segurança técnica para tomada de decisão</strong> e
              planejamento das intervenções.
            </p>

            <p>O projeto contribui para:</p>

            <ul className="lista-prad">
              <li>
                <strong>redução de riscos geotécnicos</strong>
              </li>
              <li>
                <strong>mitigação de impactos ambientais</strong>
              </li>
              <li>
                <strong>melhoria das condições futuras de uso da área</strong>
              </li>
              <li>
                <strong>alinhamento com exigências ambientais</strong>
              </li>
            </ul>
          </div>

          <div className="case-destaque scroll-reveal-zoom">
            <h5>PRAD em MG: Projeto Técnico que Garante Resultado</h5>
            <p>
              Este case demonstra que a qualidade do{" "}
              <strong>projeto de recuperação de área degradada</strong> é
              determinante para o sucesso da reabilitação ambiental,
              especialmente em áreas impactadas por mineração.
            </p>
            <p>
              A elaboração de um PRAD eficiente exige diagnóstico preciso,
              domínio técnico e capacidade de propor soluções compatíveis com a
              realidade do terreno e do empreendimento.
            </p>
          </div>

          <div className="cta-container">
            <div className="cta-text">
              <h3>Precisa elaborar um PRAD?</h3>

              <p>
                Se sua empresa possui áreas degradadas, passivos ambientais ou
                necessidade de regularização associada à mineração, o primeiro
                passo é um projeto técnico bem estruturado.
              </p>

              <p>
                Atuamos com elaboração de <strong>PRAD em Minas Gerais</strong>,
                projetos de estabilização de taludes e soluções para recuperação
                ambiental, com foco em viabilidade, segurança e conformidade.
              </p>

              <p>
                Entre em contato e entenda como podemos estruturar a solução
                ideal para o seu projeto.
              </p>
            </div>

       <div className="cta-button-wrapper">
              <a
                href="https://wa.me/5532984053160?text=Olá, gostaria de solicitar um orçamento para elaboração de um PRAD"
                target="_blank"
                rel="noopener noreferrer"
                className="cta-button"
              >
                Orçamento
              </a>
            </div>
          </div>
        </section>
      </main>
      <Projetos />
      <Servicos />
      <Contato />
    </div>
  );
}

export default ProjetoRecuperacaoAreasDegradadas;
